const isCorrectPhone = phone => /^\((9|8|4|3)\d{2}\)\d{3}-\d{2}-\d{2}$/i.test(phone)

export const mustBePhoneNumber = phone => /^\(\d{3}\)\d{3}-\d{2}-\d{2}$/i.test(phone)
export default isCorrectPhone
